import axios from 'axios'
import router from '../router'
import Icon from "ant-design-vue/es/icon";
import Vue from "vue"

const prefix = process.env.VUE_APP_API_BASE_URL;

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(prefix + url, {
            params
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            if (error.response.status === 401) {
                Vue.prototype.$notification.open({
                    message: '未登录！禁止操作！',
                    description:
                        '即将跳转登录页面……',
                    icon: (h) => {
                        return h(Icon, {
                            attrs: {type: 'close-circle', style: 'color: red'}
                        });
                    }
                });
                setTimeout(() => {
                    router.push("/login")
                }, 2800)
            } else if (error.response.status === 403) {
                Vue.prototype.$notification.open({
                    message: '没有权限',
                    description:
                        '您无权访问此页面',
                    icon: (h) => {
                        return h(Icon, {
                            attrs: {type: 'close-circle', style: 'color: red'}
                        });
                    }
                });
            } else {
                Vue.prototype.$notification.open({
                    message: '系统错误',
                    description:
                        '请稍后重试……或联系管理员',
                    icon: (h) => {
                        return h(Icon, {
                            attrs: {type: 'close-circle', style: 'color: red'}
                        });
                    }
                });
            }
            reject(error);
        });
    });
}

export function get2(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(prefix + url, {
            params
        }).then(response => {
            if (!response.data.success) {
                Vue.prototype.$notification.open({
                    message: '操作失败',
                    description: response.data.message,
                    icon: (h) => {
                        return h(Icon, {
                            attrs: {type: 'close-circle', style: 'color: red'}
                        });
                    }
                })
            } else {
                resolve(response.data);
            }
        }).catch(error => {
            if (error.response.status === 401) {
                Vue.prototype.$notification.open({
                    message: '未登录！禁止操作！',
                    description:
                        '即将跳转登录页面……',
                    icon: (h) => {
                        return h(Icon, {
                            attrs: {type: 'close-circle', style: 'color: red'}
                        });
                    }
                });
                setTimeout(() => {
                    router.push("/login")
                }, 2800)
            } else if (error.response.status === 403) {
                Vue.prototype.$notification.open({
                    message: '没有权限',
                    description:
                        '您无权访问此页面',
                    icon: (h) => {
                        return h(Icon, {
                            attrs: {type: 'close-circle', style: 'color: red'}
                        });
                    }
                });
            } else {
                Vue.prototype.$notification.open({
                    message: '系统错误',
                    description:
                        '请稍后重试……或联系管理员',
                    icon: (h) => {
                        return h(Icon, {
                            attrs: {type: 'close-circle', style: 'color: red'}
                        });
                    }
                });
            }
            reject(error);
        });
    });
}

export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.post(prefix + url, params)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                if (error.response.status === 401) {
                    Vue.prototype.$notification.open({
                        message: '未登录！禁止操作！',
                        description:
                            '即将跳转登录页面……',
                        icon: (h) => {
                            return h(Icon, {
                                attrs: {type: 'close-circle', style: 'color: red'}
                            });
                        }
                    });
                    setTimeout(() => {
                        router.push("/login")
                    }, 2800)
                } else if (error.response.status === 403) {
                    Vue.prototype.$notification.open({
                        message: '没有权限',
                        description:
                            '您无权访问此页面',
                        icon: (h) => {
                            return h(Icon, {
                                attrs: {type: 'close-circle', style: 'color: red'}
                            });
                        }
                    });
                } else {
                    Vue.prototype.$notification.open({
                        message: '系统错误',
                        description:
                            '请稍后重试……或联系管理员',
                        icon: (h) => {
                            return h(Icon, {
                                attrs: {type: 'close-circle', style: 'color: red'}
                            });
                        }
                    });
                }
                reject(error);
            });
    });
}


export function post2(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.post(prefix + url, params)
            .then(response => {
                if (!response.data.success) {
                    Vue.prototype.$notification.open({
                        message: '操作失败',
                        description: response.data.message,
                        icon: (h) => {
                            return h(Icon, {
                                attrs: {type: 'close-circle', style: 'color: red'}
                            });
                        }
                    })
                    reject(response)
                } else {
                    resolve(response);
                }
            })
            .catch(error => {
                if (error.response.status === 401) {
                    Vue.prototype.$notification.open({
                        message: '未登录！禁止操作！',
                        description:
                            '即将跳转登录页面……',
                        icon: (h) => {
                            return h(Icon, {
                                attrs: {type: 'close-circle', style: 'color: red'}
                            });
                        }
                    });
                    setTimeout(() => {
                        router.push("/login")
                    }, 2800)
                } else if (error.response.status === 403) {
                    Vue.prototype.$notification.open({
                        message: '没有权限',
                        description:
                            '您无权访问此页面',
                        icon: (h) => {
                            return h(Icon, {
                                attrs: {type: 'close-circle', style: 'color: red'}
                            });
                        }
                    });
                } else {
                    Vue.prototype.$notification.open({
                        message: '系统错误',
                        description:
                            '请稍后重试……或联系管理员',
                        icon: (h) => {
                            return h(Icon, {
                                attrs: {type: 'close-circle', style: 'color: red'}
                            });
                        }
                    });
                }
                reject(error);
            });
    });
}

export function request(url, params = {}, method, handleError = true) {
    return new Promise((resolve, reject) => {
        axios.request({
            url: prefix + url,
            method,
            params: method === 'get' ? params : null,
            data: method === 'post' ? params : null,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('userToken')
            }
        }).then(response => {
            const responseBody = response.data
            if (responseBody.code === 200 || !handleError) {
                resolve(responseBody)
                return;
            }
            if (responseBody.code === 401) { // 跳转登录
                Vue.prototype.$notification.open({
                    message: '未登录或登录已失效',
                    description:
                        '即将跳转登录页面…',
                    icon: (h) => {
                        return h(Icon, {
                            attrs: {type: 'close-circle', style: 'color: red'}
                        });
                    }
                });
                setTimeout(() => {
                    router.push("/login")
                }, 2800)
            } else {
                Vue.prototype.$message
                    .error(responseBody.msg ? responseBody.msg : '服务器出错，请联系管理员');
            }
            reject(response.data)
        }).catch(error => {
            if (!handleError) {
                resolve({})
                return;
            }
            Vue.prototype.$notification.open({
                message: '请求错误',
                description:
                    '请稍后重试或联系管理员',
                icon: (h) => {
                    return h(Icon, {
                        attrs: {type: 'close-circle', style: 'color: red'}
                    });
                }
            });
            reject(error);
        });
    });
}

// 在 base.js 中添加
export function getFileStream(url, params = {}, method) {
    return new Promise((resolve, reject) => {
        axios({
            url: prefix + url,
            method,
            params: method === 'get' ? params : null,
            data: method === 'post' ? params : null,
            responseType: 'blob', // 关键：设置响应类型为 blob
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('userToken')
            }
        }).then(response => {// 检查返回的内容类型
            // 检查返回的内容类型
            const contentType = response.headers['content-type'];

            // 如果是JSON格式，说明可能是错误信息
            if (contentType && contentType.includes('application/json')) {
                // 将 blob 转换为文本然后解析为 JSON
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        // 处理错误信息
                        if (errorData.code === 401) {
                            Vue.prototype.$notification.open({
                                message: '未登录或登录已失效',
                                description: '即将跳转登录页面…',
                                icon: (h) => {
                                    return h(Icon, {
                                        attrs: {type: 'close-circle', style: 'color: red'}
                                    });
                                }
                            });
                            setTimeout(() => {
                                router.push("/login")
                            }, 2800)
                        } else {
                            Vue.prototype.$message
                                .error(errorData.msg ? errorData.msg : '服务器出错，请联系管理员');
                        }
                        reject(errorData);
                    } catch (e) {
                        reject(e);
                    }
                };
                reader.readAsText(response.data);
                return;
            }

            let filename = 'download'; // 默认文件名
            const headers = response.headers;
            let disposition = null;

            // 遍历所有响应头，查找 Content-Disposition
            for (const key in headers) {
                if (key.toLowerCase() === 'content-disposition') {
                    disposition = headers[key];
                    break;
                }
            }

            if (disposition && disposition.indexOf('attachment') !== -1) {
                // 处理不同格式的文件名
                let filenameMatch = null;

                // 优先处理 filename*= 格式 (RFC 5987 标准，支持编码)
                const encodedFilenameRegex = /filename\*=(?:UTF-8'')?([^;\n]+)/i;
                const encodedMatch = encodedFilenameRegex.exec(disposition);

                if (encodedMatch && encodedMatch[1]) {
                    try {
                        // 解码 URL 编码的文件名
                        filename = decodeURIComponent(encodedMatch[1]);
                    } catch (e) {
                        // 解码失败则尝试其他方式
                        const regularFilenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        const regularMatch = regularFilenameRegex.exec(disposition);
                        if (regularMatch && regularMatch[1]) {
                            filename = regularMatch[1].replace(/['"]/g, '');
                        }
                    }
                } else {
                    // 处理普通的 filename 格式
                    const regularFilenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const regularMatch = regularFilenameRegex.exec(disposition);
                    if (regularMatch && regularMatch[1]) {
                        const matchedFilename = regularMatch[1].replace(/['"]/g, '');
                        try {
                            // 尝试解码，可能是 URL 编码
                            filename = decodeURIComponent(matchedFilename);
                        } catch (e) {
                            // 解码失败则使用原始值
                            filename = matchedFilename;
                        }
                    }
                }
            }

            // 创建一个隐藏的a标签用于下载
            const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', filename); // 使用服务器返回的文件名
            document.body.appendChild(link);
            link.click();

            // 清理创建的元素和URL对象
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
            resolve('下载成功');
        }).catch(error => {
            Vue.prototype.$notification.open({
                message: '请求错误',
                description:
                    '请稍后重试或联系管理员',
                icon: (h) => {
                    return h(Icon, {
                        attrs: {type: 'close-circle', style: 'color: red'}
                    });
                }
            });
            reject(error);
        });
    });
}
